import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { ChevronDown, ChevronUp } from "../../icons";
import { getSitemapIcon } from "../../pages/sitemap/sitemapIcons";

function NavigationItem({
  children,
  className = "",
  icon,
  id,
  onClick,
  show,
  text,
}) {
  const itemIcon = getSitemapIcon(icon);
  const itemId = id.toLowerCase().replace(/\s+/g, "-");

  return (
    <li>
      <button
        className={classNames(
          "btn",
          className,
          show ? "" : "collapsed"
        )}
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={`${itemId}-navigation-item`}
        aria-expanded={show.toString()}
        aria-controls={id}
        onClick={onClick}
      >
        <span>
          {itemIcon && (
            <FontAwesomeIcon icon={itemIcon} fixedWidth className="me-2" />
          )}
          {text}
        </span>
        <FontAwesomeIcon
          icon={show ? ChevronUp : ChevronDown}
          size="sm"
        />
      </button>
      <div
        className={classNames("collapse", show ? "show" : "")}
        id={`${itemId}-navigation-item`}
      >
        <ul className="nav flex-column">{children}</ul>
      </div>
    </li>
  );
}

export default NavigationItem;
